import DeleteIcon from "@mui/icons-material/Clear";
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
} from "@mui/material";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import AddButton from "../../../../../common/components/functional/addButton/AddButton";
import DialogComponent from "../../../../../common/components/functional/dialogs/DialogComponent";
import FormSection from "../../../../../common/components/functional/formSection/FormSection";
import { ReactComponent as EditIcon } from "../../../../../common/icons/editFilled.svg";
import { Union } from "../../unionsApi";
import UnionPaymentInfoModal from "./UnionPaymentInfoModal";

interface Props {
  union: Union;
  setUnion: (union: Union) => void;
}

const UnionPaymentInfo = ({ union, setUnion }: Props) => {
  const [selecteCompanyId, setSelecteCompanyId] = useState<string>("");

  const { t } = useTranslation();

  const handleDelete = (paymentId: string) => {
    setUnion({
      ...union,
      unionPaymentInfo: union.unionPaymentInfo.filter(
        (item) => item.eezyCompanyId !== paymentId,
      ),
    });
  };

  const sortedPaymentInfo = [...(union?.unionPaymentInfo || [])].sort((a, b) =>
    (a?.name || "").localeCompare(b?.name || ""),
  );

  return (
    <FormSection title={t("settings:unionPaymentInfo")}>
      <Box
        sx={{
          padding: "20px",
          display: "flex",
          flexDirection: "column",
          width: "70%" || "unset",
        }}
      >
        {sortedPaymentInfo?.length > 0 && (
          <TableContainer>
            <Table>
              <TableBody>
                <TableRow>
                  <TableCell sx={{ padding: "6px" }}>
                    {t("settings:company")}
                  </TableCell>
                  <TableCell sx={{ padding: "6px" }}>
                    {t("settings:paymentReferenceTemplate")}
                  </TableCell>
                  <TableCell sx={{ padding: "6px" }} />
                  <TableCell sx={{ padding: "6px" }} />
                </TableRow>
                {sortedPaymentInfo.length === 0 ? (
                  <TableRow>
                    <TableCell colSpan={4} align="center">
                      {t("settings:noUnionPaymentInfosToShow")}
                    </TableCell>
                  </TableRow>
                ) : (
                  sortedPaymentInfo.map((payment, index) => (
                    <TableRow key={index}>
                      <TableCell sx={{ fontWeight: 600, padding: "6px" }}>
                        {payment.name}
                      </TableCell>
                      <TableCell sx={{ padding: "6px" }}>
                        {payment?.paymentReferenceTemplate || ""}
                      </TableCell>

                      <TableCell sx={{ padding: "6px" }}>
                        <Box
                          sx={{
                            display: "flex",
                            flexDirection: "row",
                            alignItems: "center",
                            whiteSpace: "nowrap",
                            color: "rgba(0, 0, 0, 0.52)",
                            cursor: "pointer",
                          }}
                          onClick={() =>
                            payment?.eezyCompanyId &&
                            setSelecteCompanyId(payment.eezyCompanyId)
                          }
                        >
                          <EditIcon style={{ marginRight: "10px" }} />
                          {t("common:edit")}
                        </Box>
                      </TableCell>
                      <TableCell sx={{ padding: "6px" }}>
                        <Box
                          sx={{
                            display: "flex",
                            flexDirection: "row",
                            alignItems: "center",
                            whiteSpace: "nowrap",
                            color: "rgba(0, 0, 0, 0.52)",
                            cursor: "pointer",
                          }}
                          onClick={() =>
                            payment?.eezyCompanyId &&
                            handleDelete(payment.eezyCompanyId)
                          }
                        >
                          <DeleteIcon
                            sx={{
                              marginRight: "5px",
                            }}
                          />
                          {t("common:delete")}
                        </Box>
                      </TableCell>
                    </TableRow>
                  ))
                )}
              </TableBody>
            </Table>
          </TableContainer>
        )}
        <AddButton
          variant="outlined"
          sx={{
            margin: "24px 0px 32px 8px",
            alignSelf: "flex-start",
            background: "#f7f7f9",
            height: "36px",
            borderRadius: "18px",
            borderColor: "rgba(74, 29, 156, 0.5)",
          }}
          label={t("settings:addNewUnionPaymentInfo")}
          onClick={() => setSelecteCompanyId("new")}
        />
        <DialogComponent
          open={selecteCompanyId !== ""}
          onClose={() => setSelecteCompanyId("")}
          autoWidth
          DialogContentProps={{
            sx: { padding: "0px" },
          }}
        >
          <UnionPaymentInfoModal
            union={union}
            setUnion={setUnion}
            selectedCompanyId={selecteCompanyId}
            setSelectedCompanyId={setSelecteCompanyId}
            title={
              selecteCompanyId === "new"
                ? t("settings:addNewUnionPaymentInfo")
                : t("settings:editUnionPaymentInfo")
            }
          />
        </DialogComponent>
      </Box>
    </FormSection>
  );
};

export default UnionPaymentInfo;
